module.exports = __webpack_public_path__ + "static/media/mancha_beige.fa687414.png";